<script>
export default {
  props: {
    module: Object,
    idx: Number,
  },
};
</script>
<template>
  <FBody
    v-if="module"
    :module="module"
    fixed-label
  >
    <RowSpan>
      <ColSpan span="6">
        <FItem
          :module="module.getItem('fio')"
        />
      </ColSpan>
      <ColSpan span="2">
        <FItem
          :module="module.getItem('gender')"
        />
      </ColSpan>
      <ColSpan span="2">
        <FItem
          :module="module.getItem('birthday')"
        />
      </ColSpan>
      <ColSpan span="2">
      <FItem
        :module="module.getItem('citizenship')"
      />
      </ColSpan>
    </RowSpan>
    <RowSpan>
      <ColSpan span="3">
        <FItem
          :module="module.getItem('documentType')"
        />
      </ColSpan>
      <ColSpan span="3">
        <FItem
          :module="module.getItem('documentNumber')"
        />
      </ColSpan>
      <ColSpan span="6">
        <FItem
          :module="module.getItem('documentFrom')"
        />
      </ColSpan>
    </RowSpan>
  </FBody>
</template>
<style lang="scss">

</style>
